import { defaultApiState } from '../api.state';

export const productMutations = {
  GET_PRODUCTS_LOADING(state) {
    state.apiState.getProducts = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_PRODUCTS_SUCCESS(state, payload) {
    state.apiState.getProducts = {
      ...defaultApiState,
      success: true,
    };
    state.products = payload;
  },
  GET_PRODUCTS_ERROR(state, error) {
    state.apiState.getProducts = {
      ...defaultApiState,
      error,
    };
  },

  ADD_PRODUCT_LOADING(state) {
    state.apiState.addProduct = {
      ...defaultApiState,
      loading: true,
    };
  },
  ADD_PRODUCT_SUCCESS(state) {
    state.apiState.addProduct = {
      ...defaultApiState,
      success: true,
    };
  },
  ADD_PRODUCT_ERROR(state, error) {
    state.apiState.addProduct = {
      ...defaultApiState,
      error,
    };
  },

  GET_PRODUCT_RESET(state) {
    state.apiState.getProduct = {
      ...defaultApiState,
    };
    state.product = undefined;
  },
  GET_PRODUCT_LOADING(state) {
    state.apiState.getProduct = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_PRODUCT_SUCCESS(state, payload) {
    state.apiState.getProduct = {
      ...defaultApiState,
      success: true,
    };
    state.product = payload;
  },
  GET_PRODUCT_ERROR(state, error) {
    state.apiState.getProduct = {
      ...defaultApiState,
      error,
    };
  },

  UPDATE_PRODUCT_LOADING(state) {
    state.apiState.updateProduct = {
      ...defaultApiState,
      loading: true,
    };
  },
  UPDATE_PRODUCT_SUCCESS(state) {
    state.apiState.updateProduct = {
      ...defaultApiState,
      success: true,
    };
  },
  UPDATE_PRODUCT_ERROR(state, error) {
    state.apiState.updateProduct = {
      ...defaultApiState,
      error,
    };
  },

  DELETE_PRODUCT_LOADING(state) {
    state.apiState.deleteProduct = {
      ...defaultApiState,
      loading: true,
    };
  },
  DELETE_PRODUCT_SUCCESS(state, payload) {
    state.apiState.deleteProduct = {
      ...defaultApiState,
      success: true,
    };
    state.products = state.products.filter(o => o.id !== payload.id);
  },
  DELETE_PRODUCT_ERROR(state, error) {
    state.apiState.deleteProduct = {
      ...defaultApiState,
      error,
    };
  },
};
